module.exports = __webpack_public_path__ + "media/images/icons/audio-spectrum-130f05d5407f42ffc38e2b9627d12ef8.svg";